export default "__VITE_ASSET__B_uop8$S__"